import { cashXPdfApi } from "../../api";

const CashXPdfService = {

    /**
     * 📄 Descargar PDF
     * del Corte X
     *
     * GET /api/pdf/cash/x
     */
    download: async (): Promise<{
        blob: Blob;
        fileName: string | null;
    }> => {

        const response =
            await cashXPdfApi.fetchBlob("");

        return {

            blob: response.data,

            fileName:
                response.fileName ||
                "corte_x.pdf",
        };
    },
};

export default CashXPdfService;